import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { FadeUp } from "@/components/motion/Reveal";
import { MANIFESTO, IMAGES, PROFILE } from "@/data/content";

const Manifesto = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const imgY = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <section
      id="approach"
      ref={ref}
      data-testid="manifesto-section"
      className="mx-auto max-w-[1600px] scroll-mt-24 px-6 py-28 md:px-12 md:py-40"
    >
      <FadeUp className="mb-16 flex items-end justify-between border-b border-line pb-8 md:mb-24">
        <div>
          <p className="mb-4 font-mono text-xs uppercase tracking-[0.2em] text-signal">/ How I Work</p>
          <h2 className="max-w-2xl font-display text-3xl font-medium uppercase leading-none tracking-tight text-chalk sm:text-4xl md:text-5xl">
            The way I think about design
          </h2>
        </div>
        <span className="hidden font-mono text-xs uppercase tracking-[0.2em] text-ash md:block">04 / Principles</span>
      </FadeUp>

      <div className="grid grid-cols-1 gap-16 lg:grid-cols-12">
        {/* Portrait */}
        <div className="lg:col-span-4">
          <div className="relative aspect-[3/4] overflow-hidden border border-line">
            <motion.img
              style={{ y: imgY, scale: 1.15 }}
              src={IMAGES.scott}
              alt="Portrait of Scott Whitty"
              loading="lazy"
              className="h-full w-full object-cover object-top brightness-105 contrast-105 transition-all duration-700 hover:brightness-115"
            />
            <div className="absolute bottom-0 left-0 right-0 flex items-center justify-between border-t border-line bg-black/70 px-4 py-3 backdrop-blur-sm">
              <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-ash">{PROFILE.name}</span>
              <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-chalk">{PROFILE.years} Years</span>
            </div>
          </div>
        </div>

        {/* Chapters */}
        <div className="lg:col-span-8 lg:pl-8">
          <div className="flex flex-col">
            {MANIFESTO.map((c, i) => (
              <FadeUp
                key={c.no}
                delay={i * 0.05}
                className="group grid grid-cols-1 gap-6 border-b border-line py-10 md:grid-cols-12 md:py-12"
              >
                <div className="md:col-span-3">
                  <span className="font-display text-5xl font-semibold text-outline transition-colors duration-500 group-hover:text-signal md:text-6xl">
                    {c.no}
                  </span>
                </div>
                <div className="md:col-span-9">
                  <h3 className="mb-3 font-display text-2xl font-medium tracking-tight text-chalk">{c.title}</h3>
                  <p className="max-w-xl text-base leading-relaxed text-ash">{c.body}</p>
                </div>
              </FadeUp>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Manifesto;
